module.exports = __webpack_public_path__ + "img/1515049774.f772089f.jpg";